import { isNumber } from 'lodash';

export class EnumService {
  static getNumberValues(numberEnum: object): number[] {
    return Object.values(numberEnum).filter(value => isNumber(value));
  }
}
